import React, { useMemo, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import useMediaQuery from '@mui/material/useMediaQuery'
import ClearInput from '../Icons/js/ClearInput'
import Search from '../Icons/js/Search'

export default function Input ({
  onChange,
  onClear,
  value,
  variant,
  animation,
  type,
  id,
  placeholder,
  onKeyDown,
  autoComplete,
  className,
  searchFieldClassName,
  inputRootSx,
  inputRef,
  defaultValue = ''
}) {
  const [rawValue, setRawValue] = useState(defaultValue)
  const internalValue = useMemo(() => value || rawValue, [value, rawValue])
  const resize = useMediaQuery('(max-width:750px)')
  const [focused, setFocused] = useState(false)

  const setClear = () => {
    setRawValue('')
    onClear()
    setFocused(false)
  }

  return (
    <TextField
      className={className}
      inputRef={inputRef}
      variant={variant}
      id={id}
      focused={focused}
      autoComplete={autoComplete}
      onFocus={() => setFocused(true)}
      value={internalValue}
      onChange={(e) => {
        setRawValue(e.target.value)
        onChange(e)
      }}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      onClick={() => setFocused(true)}
      InputProps={{
        className: `${animation ? 'animated' : focused ? 'Mui-focused' : ''} ${searchFieldClassName || ''}`,
        sx: {
          paddingLeft: variant === 'outlined'
            ? animation && !focused ? '11px' : '15px'
            : undefined
        },
        startAdornment: type === 'search' && (
          <InputAdornment position='start' onClick={() => setFocused(true)}>
            <Search width={23} />
          </InputAdornment>
        ),
        endAdornment: value !== '' && (
          <InputAdornment position='end'>
            <IconButton
              aria-label='Clear search'
              onClick={setClear}
              sx={{ padding: 0 }}
            >
              <ClearInput width={17} />
            </IconButton>
          </InputAdornment>
        )
      }}
      sx={(theme) => ({
        '& .MuiInputBase-root': {
          background: theme.palette.quaternary.main,
          color: theme.palette.tertiary.main,
          fontSize: 13,
          height: 40,
          lineHeight: 'normal',
          width: resize ? 350 : 265,
          ...(resize && {
            boxShadow: '0px 0px 3px #00000029',
            marginLeft: '45px'
          }),
          ...inputRootSx
        },
        '& .MuiInputBase-input': { padding: '10px 0px' },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          boxShadow: '0px 0px 3px #00000029'
        }
      })}
    />
  )
}
